import * as React from 'react';
import { DesktopProductDetailsCell } from '../../cells/product-details/desktop-items';
import { getI18n } from 'services/i18n-service';
import { InfoIconCell } from '../../cells/info-icon/component';
import { OperationItemRowBase } from './base-row';
// import { ProductNameCell } from '../../cells/product-name/component';
import { Props } from './props';
import { StatusCell } from '../../cells/status/component';
import { Table } from 'semantic-ui-react';
import { TextCell } from '../../cells/text/component';
import { translations } from 'types/translations';

export class DesktopRow extends OperationItemRowBase {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const operationItem = this.props.operationItem;
    const i18n = getI18n();
    const status = !this.props.isOnline && operationItem.epc.status
      && operationItem.epc.status.startsWith(i18n.t(translations.Pending))
      ? i18n.t(translations.AwaitingConnection)
      : operationItem.epc.status;

    return (
      <Table.Row className={this.props.isActive ? 'active-row inner-operation-item-row' : 'inner-operation-item-row'}
        onClick={this.props.onClick}>
        <Table.Cell textAlign="center" width={1}>
          <InfoIconCell operationItem={this.props.operationItem} language={this.props.language} />
        </Table.Cell>
        {/* <Table.Cell className="product-name-cell" width={6}>
          <ProductNameCell productCode={this.props.operationItem.epc.productCode} />
        </Table.Cell> */}
        <Table.Cell width={6}>
          <DesktopProductDetailsCell operationItem={this.props.operationItem} language={this.props.language} />
        </Table.Cell>
        <Table.Cell width={8} className="status-cell">
          <TextCell text={status} />
        </Table.Cell>
        <Table.Cell textAlign="center" width={1}>
          <StatusCell operationItem={this.props.operationItem} isOnline={this.props.isOnline} language={this.props.language} />
        </Table.Cell>
      </Table.Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/row/desktop-row.tsx